module.exports = __webpack_public_path__ + "static/media/main idea.b2b4b4fa.mp3";